(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pts-clearance-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    const panel = document.getElementById('pts-clearance-panel');
    const reopen = document.getElementById('pts-clearance-reopen');
    if (!panel || !reopen) return;
    const preview = new URLSearchParams(location.search).get('pts_clearance_preview') === '1';
    if (Number(panel.dataset.remaining) < 1 && !preview) return;
    let autoOpenTimer;
    const open = (focus = false) => {
      panel.hidden = false;
      reopen.hidden = true;
      reopen.setAttribute('aria-expanded', 'true');
      window.clearTimeout(autoOpenTimer);
      if (focus) panel.querySelector('button').focus();
    };
    const close = (focus = false) => {
      window.clearTimeout(autoOpenTimer);
      panel.hidden = true;
      reopen.hidden = false;
      reopen.setAttribute('aria-expanded', 'false');
      if (focus) reopen.focus();
    };
    panel.querySelector('button').addEventListener('click', () => close(true));
    panel.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(true); });
    reopen.addEventListener('click', (event) => { event.preventDefault(); open(true); });
    reopen.hidden = false;
    autoOpenTimer = window.setTimeout(() => open(false), 5000);
  })();
  } catch(e) { console.error(e); }
})();

})();
